import { useFormContext, useFormField } from '@calendly/form';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { useEffect, useState } from 'react';
import { getDefaultIntervals } from 'components/availability/form/utils';
import { CustomHoursView } from 'components/event_type_edit';
import { V4DefaultHoursView } from './v4_default_hours_view';
const customHoursWrapperCss = "cheay0x";
export const V4IntervalsSection = ({
  formPath,
  readOnly = false
}) => {
  const {
    setFieldValue
  } = useFormContext();
  const [{
    value: {
      availableHours: persistedAvailableHours,
      usingCustomHours
    } = {}
  }] = useFormField({
    name: formPath
  });
  const [availableHours, setAvailableHours] = useState(persistedAvailableHours);
  const [availableHoursCache, setAvailableHoursCache] = useState({});
  const isExtraSmallPhone = useDeviceType('isSmallPhone');
  useEffect(() => {
    setAvailableHours(persistedAvailableHours);
  }, [persistedAvailableHours]);
  const onHoursUpdated = (day, intervals) => {
    const updatedHours = {
      ...availableHours,
      [day]: intervals
    };
    setAvailableHours(updatedHours);
    setFieldValue(`${formPath}.usingCustomHours`, true);
    setFieldValue(`${formPath}.usingSecondarySchedule`, false);
    setFieldValue(`${formPath}.availableHours`, updatedHours);
  };
  const addOrRemoveDay = (added, day) => {
    if (!added) {
      setAvailableHoursCache(cache => ({
        ...cache,
        [day]: availableHours[day]
      }));
    }
    onHoursUpdated(day, added ? availableHoursCache[day] || getDefaultIntervals() : []);
  };
  const cloneWeekdayAvailability = (weekday, targetWeekdays) => {
    const sourceIntervals = availableHours[weekday] || [];
    const updatedHours = targetWeekdays.reduce((hours, targetWeekday) => ({
      ...hours,
      [targetWeekday]: sourceIntervals
    }), availableHours);
    setAvailableHours(updatedHours);
    setFieldValue(`${formPath}.usingCustomHours`, true);
    setFieldValue(`${formPath}.usingSecondarySchedule`, false);
    setFieldValue(`${formPath}.availableHours`, updatedHours);
  };
  if (readOnly || !usingCustomHours) {
    return <V4DefaultHoursView days={availableHours} />;
  }
  return <div className={customHoursWrapperCss} data-testid="v4-custom-hours-view">
      <CustomHoursView allowCopy alwaysAbbreviate cloneWeekdayAvailability={cloneWeekdayAvailability} days={availableHours} handleCheckboxClick={addOrRemoveDay} isExtraSmallPhone={isExtraSmallPhone} setWdayIntervals={onHoursUpdated} v4Styling />
    </div>;
};

require("./v4_intervals_section.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./v4_intervals_section.js");